import { formatGeolocation } from 'utils';
import format from 'date-fns/format';
import addMinutes from 'date-fns/add_minutes';
import differenceInHours from 'date-fns/difference_in_hours';

import { getI18nMessages } from 'utils/i18n';

export const normalizeStoreHour = (storeHour, lang) => {
  if (!storeHour) return null;
  const date = new Date();
  const from = new Date(date.setHours(...storeHour.open.split(':')));
  const to = addMinutes(from, Number(storeHour.close));
  const { open_24_hours: open24hours } = getI18nMessages(lang);
  if (from && to && differenceInHours(from, to) === 24) {
    return {
      ...storeHour,
      close: format(to, 'HH:mm:ss'),
      stringToView: open24hours,
    };
  }

  return {
    ...storeHour,
    close: format(to, 'HH:mm:ss'),
    stringToView: `${format(from, 'hh:mma')} - ${format(to, 'hh:mma')}`,
  };
};

// Selectors
export const selectStores = (state) => state.stores.list;

export const selectRawStore = (state, storeId) => {
  return state.stores.list[storeId] || null;
};

export const selectStore = (state, storeId) => {
  const store = selectRawStore(state, storeId);
  return store;
};

export const selectStoreIdByCustomerCode = (state, customerCode) => {
  return state.stores.idByCustomerCode[customerCode] || null;
};

export const selectStoreIdByExtId = (state, extId) => {
  return state.stores.idBy_id[extId] || null;
};

export const selectStoreIdByCustomerCodeOrExtId = (state, customerCode, extId) => {
  return selectStoreIdByCustomerCode(state, customerCode) || selectStoreIdByExtId(state, extId);
};

export const selectCurrentStoreId = (state) => state.stores.current;
export const selectCurrentStore = (state) => {
  const currentStoreId = selectCurrentStoreId(state);
  return currentStoreId && selectStore(state, currentStoreId);
};

export const selectCurrentStoreGeolocation = (state) => {
  const currentStoreId = selectCurrentStoreId(state);
  const currentStore = selectRawStore(state, currentStoreId);
  if (currentStore) {
    const { lat, lng } = currentStore;
    return formatGeolocation({ lat, lng }, 'currentStore');
  }
  return null;
};
